import angular from 'angular';
import moment from 'moment';
import _ from 'lodash';

(function() {
    'use strict';
    angular.module('app.core').factory('AuditFilter', AuditFilterData);

    AuditFilterData.$inject = ['AUDIT'];

    /* @ngInject */
    function AuditFilterData(AUDIT) {
        AuditFilter.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            preparBeforeSearch: preparBeforeSearch,
            setPage: setPage,
            setPageSize: setPageSize,
            setSort: setSort,
            resetSort: resetSort
        };

        function AuditFilter(auditFilterData) {
            if (!auditFilterData) {
                this.buildEmpty();
            } else {
                this.build(auditFilterData);
            }
        }

        return AuditFilter;

        /////////////////////

        function buildEmpty() {
            this.dateFrom = new Date();
            this.dateTo = new Date();
            this.actions = null;
            this.authorId = null;
            this.pageCriteria = {
                pageSize: AUDIT.audits.pagination.defaultPageSize,
                page: AUDIT.audits.pagination.defaultPage,
                sorts: AUDIT.audits.pagination.defaultSort
            };
        }

        function build(auditFilterData) {
            this.dateFrom = auditFilterData.dateFrom || new Date();
            this.dateTo = auditFilterData.dateTo || new Date();
            this.actions = auditFilterData.actions;
            this.authorId = auditFilterData.authorId;
            this.pageCriteria = {
                pageSize: auditFilterData.pageSize || AUDIT.audits.pagination.defaultPageSize,
                page: auditFilterData.page || AUDIT.audits.pagination.defaultPage,
                sorts: _setSort(auditFilterData.sorts)
            };
        }

        function _setSort(sorts) {
            if (!sorts || sorts.length === 0) {
                return AUDIT.audits.pagination.defaultSort;
            }
            return sorts;
        }

        function preparBeforeSearch() {
            var clone = new AuditFilter(this);
            clone.pageCriteria = this.pageCriteria;
            clone.dateFrom = this.dateFrom
                ? moment(this.dateFrom)
                      .startOf('day')
                      .toDate()
                : null;
            clone.dateTo = this.dateTo
                ? moment(this.dateTo)
                      .endOf('day')
                      .toDate()
                : null;
            clone.actions = _.flatten(this.actions);
            return clone;
        }

        /**
         * Indiquer la page
         */
        function setPage(page) {
            this.pageCriteria.page = page;
        }

        /**
         * Changement de pagination
         */
        function setPageSize(pageSize) {
            this.pageCriteria.pageSize = pageSize;
        }

        /**
         * Mise à jour du tri (tri sur une seule colonne)
         */
        function setSort(sorts) {
            this.pageCriteria.sorts = sorts;
        }

        /**
         * Lorsqu'on ne souhaite aucun tri
         */
        function resetSort() {
            this.pageCriteria.sorts = [];
        }
    }
})();
